import React, { useState } from 'react';
import { InertiaLink } from '@inertiajs/inertia-react';
// import Logo from '@/Shared/Logo';
import { Container, Col, Row, Nav } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import {faEnvelope, faMapMarkerAlt, faPhoneAlt} from '@fortawesome/free-solid-svg-icons'
// import MainSocialMenu from '@/Shared/Layouts/Menus/MainSocialMenu';
import ContactoMenu from '@/Shared/Layouts/Menus/ContactoMenu';

export default () => {
	return <Container>
		<Row className="justify-content-between">
			<Col xs="auto">
				{/* <Nav>
					<Nav.Item as="li">
						<Nav.Link as="span" className="">
							<a className="pr-1" href="tel:4701392" >
								<FontAwesomeIcon icon={faPhoneAlt} /> 470-1392
							</a>
							/
							<a className="pl-1" href="tel:2650312">
								265-0312
							</a>
						</Nav.Link>
					</Nav.Item>
					<Nav.Item as="li">
						<Nav.Link href="mailto:ventas@iqsac.com.pe" target="_blank">
							<FontAwesomeIcon icon={faEnvelope} /> ventas@iqsac.com.pe
						</Nav.Link>
					</Nav.Item>
					<Nav.Item as="li">
						<Nav.Link href="#direccion" onClick={(e)=>e.preventDefault()}>
							<FontAwesomeIcon icon={faMapMarkerAlt} /> Paseo de la República 1728 - Lince - Lima
						</Nav.Link>
					</Nav.Item>
				</Nav> */}
				<ContactoMenu className="menu-contacto-header" />
			</Col>
			{/* <Col xs="auto">
				<MainSocialMenu />
			</Col> */}
		</Row>
	</Container>
}